import type { ComponentProps, FC, ReactNode } from "react";
import { useMemo } from "react";
import { clsx } from "clsx";
import type { TextColorClasses } from "../atoms";
import { Text } from "../atoms";

export const COLOR_THEMES = ["primary", "bw"] as const;
type ColorTheme = (typeof COLOR_THEMES)[number];
type Color = { text: TextColorClasses; bg: string };

const colorsByColorTheme: Record<ColorTheme, Color> = {
  primary: {
    text: "text-primary-500",
    bg: "bg-primary-50",
  },
  bw: {
    text: "text-gray-800",
    bg: "bg-gray-800/10",
  },
} as const;

export const Avatar: FC<{
  colorTheme?: ColorTheme;
  initials: string;
  image?: string | null | undefined;
  size?: string;
  className?: string;
  children?: ReactNode;
  textSize?: ComponentProps<typeof Text>["size"];
}> = ({ colorTheme = "primary", initials, image, size = "w-10 h-10", className, children, textSize }) => {
  const color = useMemo(() => colorsByColorTheme[colorTheme], [colorTheme]);

  return (
    <div
      className={clsx(
        "relative flex shrink-0 items-center justify-center overflow-hidden rounded-full",
        color.bg,
        size,
        className,
      )}>
      {children}
      {image ? (
        <img src={image} alt="profile" className="h-full overflow-hidden rounded-full object-cover" />
      ) : (
        <Text size={textSize} color={color.text} fontWeight="font-bold" className="safari-text-adjust">
          {initials}
        </Text>
      )}
    </div>
  );
};
